module.exports = __webpack_public_path__ + "img/catalogue3.31679b3c.png";